import { useNavigate, useLocation } from 'react-router'
import MainMenuSvg from '../assets/img/svg/main-menu'
import WebhooksMenuSvg from '../assets/img/svg/webhooks-menu'
import PowerBIMenuSvg from '../assets/img/svg/powerbi-menu'

const LeftSidebar = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const menu = [
    {
      id: 1,
      label: 'main',
      icon: <MainMenuSvg />,
      url: '/',
      status: location.pathname === '/' ? '-active' : '-inactive',
    },
    {
      id: 2,
      label: 'webhooks',
      icon: <WebhooksMenuSvg />,
      url: '/webhooks',
      status: location.pathname === '/webhooks' ? '-active' : '-inactive',
    },
    {
      id: 3,
      label: 'powerbi',
      icon: <PowerBIMenuSvg />,
      url: '/powerbi',
      status: location.pathname === '/powerbi' ? '-active' : '-inactive',
    },
  ]
  return (
    <div className="left-sidebar">
      <div
        className="left-sidebar-back"
        style={{
          transform:
            location.pathname === '/'
              ? 'translate(-50%, 0)'
              : location.pathname === '/webhooks'
              ? 'translate(-50%, 60px)'
              : 'translate(-50%, 120px)',
        }}
      />
      {menu.map((e) => (
        <div
          key={e.id}
          className={`left-sidebar-item${e.status}`}
          onClick={() => navigate(e.url)}
        >
          {e.icon}
        </div>
      ))}
    </div>
  )
}

export default LeftSidebar
